import { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=connecting, false=failed, obj=ready
  const [branch, setBranch] = useState(localStorage.getItem("yc_branch") || "All");
  // Shared-link mode: the person using the tool picks their own HR name (attribution only)
  const [hrSelf, setHrSelf] = useState(() => {
    try { return JSON.parse(localStorage.getItem("yc_hr_self")) || null; } catch { return null; }
  });

  const openSharedSession = async () => {
    const { data } = await api.post("/auth/shared-session");
    if (data.token) localStorage.setItem("yc_token", data.token);
    setUser(data);
  };

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/auth/me");
        setUser(data);
      } catch {
        try { await openSharedSession(); } catch { setUser(false); }
      }
    })();
  }, []);

  const selectHR = (hr) => {
    setHrSelf(hr);
    localStorage.setItem("yc_hr_self", JSON.stringify(hr));
  };
  const clearHR = () => {
    setHrSelf(null);
    localStorage.removeItem("yc_hr_self");
  };

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    if (data.token) localStorage.setItem("yc_token", data.token);
    setUser(data);
    return data;
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch {}
    localStorage.removeItem("yc_token");
    setUser(false);
  };

  const changeBranch = (b) => {
    setBranch(b);
    localStorage.setItem("yc_branch", b);
  };

  return (
    <AuthContext.Provider value={{ user, setUser, login, logout, branch, changeBranch, hrSelf, selectHR, clearHR }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
